import useGetGeocode from './useGetGeocode'
export default useGetGeocode
